import { buildCaraFallbackMessage } from '~/components/workspaces/lib/utils';

import { TemplateWorkspaceDialog } from './template-workspace-dialog';

export type UseTemplateInWorkspaceDialogProps = {
  open: boolean;
  onClose: () => void;
  templateId: string;
  templateTitle: string;
};

export const UseTemplateInWorkspaceDialog = (props: UseTemplateInWorkspaceDialogProps) => (
  <TemplateWorkspaceDialog
    open={props.open}
    onClose={props.onClose}
    title="What’s this document for?"
    description={
      <>
        Start a workspace where Cara drafts a document from {props.templateTitle}. Say who
        it&rsquo;s for and add any files Cara should fill it from. Leave both empty and Cara drafts
        it with placeholders for the details.
      </>
    }
    instructionsLabel="Instructions (optional)"
    instructionsDescription="For example, the client, the policy, or anything Cara should know."
    instructionsRows={4}
    filesDescription="Quotes, policies, or notes to fill the document from."
    buildRequest={(message, files) => ({
      message:
        message ||
        buildCaraFallbackMessage({
          customFormIds: [],
          htmlTemplateIds: [props.templateId],
          wordTemplateIds: []
        }),
      files,
      htmlDocumentTemplateIds: [props.templateId]
    })}
  />
);
